/**
 * Game constants shared between client and server.
 */

// Player constants
export const PLAYER_WHITE = "white";
export const PLAYER_BLACK = "black";

// Board index constants
export const BAR_INDEX_WHITE = -1;
export const BAR_INDEX_BLACK = 24;

// Bear off index constants - where checkers go when bearing off
export const OFF_INDEX_WHITE = -1; // White bears off to index -1
export const OFF_INDEX_BLACK = 24; // Black bears off to index 24

// Home board boundaries - where checkers must be to bear off
export const HOME_BOARD_WHITE_START = 0;
export const HOME_BOARD_WHITE_END = 5;
export const HOME_BOARD_BLACK_START = 18;
export const HOME_BOARD_BLACK_END = 23;

// Game constants
export const CHECKER_COUNT = 15;
export const TOTAL_POINTS = 24;

// Heartbeat and connection monitoring constants
export const HEARTBEAT_INTERVAL_MS = 20000; // 20 seconds (server-side)
export const CLIENT_HEARTBEAT_TIMEOUT_MS = 25000; // 25 seconds (client-side) - interval + 5s buffer
// Emote System
export const EMOTE_COOLDOWN_MS = 3000; // 3 seconds between emotes
export const EMOTE_IDS = ["thumbs_up", "laugh", "thinking", "bad_luck", "angry", "heart"] as const;
export type EmoteId = (typeof EMOTE_IDS)[number];
export const CLIENT_CONNECTION_CHECK_INTERVAL_MS = 5000; // 5 seconds (client-side) - how often to check connection health

// Turn timing constants
export const TURN_TIMEOUT_MS = 60000; // 60 seconds per turn
export const DEBUG_TIMEOUT_MS = 60000; // modify this for development/testing

// Timeout grace period - server adds this to actual timeout but doesn't report it to clients
// This prevents the visual timer from having time left when the timeout fires
export const TIMEOUT_GRACE_PERIOD_MS = 1000; // 1 second grace period

// Game status constants
export const GameStatus = {
  SETUP: "SETUP",
  IN_PROGRESS: "IN_PROGRESS",
  FINISHED: "FINISHED"
} as const;

export type GameStatus = (typeof GameStatus)[keyof typeof GameStatus];

// Game end reason constants
export const GameEndReason = {
  NORMAL: "NORMAL",
  TIMEOUT_FORFEIT: "TIMEOUT_FORFEIT",
  DOUBLE_DECLINED: "DOUBLE_DECLINED",
  RESIGNATION: "RESIGNATION"
} as const;

export type GameEndReason = (typeof GameEndReason)[keyof typeof GameEndReason];

// Win type constants
export const WinType = {
  REGULAR: "REGULAR",
  GAMMON: "GAMMON",
  BACKGAMMON: "BACKGAMMON"
} as const;

export type WinType = (typeof WinType)[keyof typeof WinType];
